import { type AppNode } from '../types';
import { getImageNodeDisplayUrl, isImageAppNode } from './getImageNodeDisplayUrl';

export const PRELOAD_IMAGE_NODES_TIMEOUT_MS = 300;

const preloadImage = (url: string) =>
  new Promise<void>((resolve) => {
    const image = new Image();

    image.src = url;
    image.decode().then(resolve, resolve);
  });

/**
 * Resolves once the image nodes' display images are decoded, or after a short cap, so a canvas
 * opened with these nodes paints them on its first frame. Never rejects.
 */
export const preloadImageNodes = (nodes: AppNode[] = []): Promise<void> => {
  const urls = nodes.filter(isImageAppNode).flatMap((node) => getImageNodeDisplayUrl(node) ?? []);

  if (urls.length === 0) {
    return Promise.resolve();
  }

  return Promise.race([
    Promise.all(urls.map(preloadImage)),
    new Promise<void>((resolve) => setTimeout(resolve, PRELOAD_IMAGE_NODES_TIMEOUT_MS)),
  ]).then(() => undefined);
};
